/**
 * Whether FloorSheet should skip rehydrating `welds` from the sections
 * blob. Used after a 409 conflict reload so a local draft (e.g. Weld ID)
 * is not wiped — same idea as PQR keeping staged edits.
 */
export function shouldSkipFloorSheetHydrate(args: {
  pipeChanged: boolean
  savedWeldsJson: string
  welds: unknown
}): boolean {
  const { pipeChanged, savedWeldsJson, welds } = args
  return (
    !pipeChanged &&
    savedWeldsJson !== '' &&
    JSON.stringify(welds) !== savedWeldsJson
  )
}
